import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const PublicPageLayout = (props) => {
    return (_jsxs("div", { className: "page-public", children: [_jsx("div", { className: "logo text-center", children: _jsx("img", { width: 190, height: 50, src: "/assets/images/subtrux-logo-black.png", alt: "SubTrux" }) }), _jsxs("div", { className: "main-body", style: { maxWidth: props.maxWidth || '400px' }, children: [props.heading &&
                        _jsx("h2", { children: props.heading }), _jsx("div", { className: "body-form", children: props.children }), props.footer &&
                        _jsx("div", { className: "body-base", children: props.footer })] })] }));
};
export default PublicPageLayout;
